<template>
  <div class="config-tab tab-content">
    <div class="resize-wrapper">
      <VueDraggableResizable
        :draggable="false"
        :active="true"
        :prevent-deactivation="true"
        :w="204"
        :minWidth="90"
        :handles="['mr']"
        axis="x"
        ><nav>
          <v-skeleton-loader type="button@5" />
        </nav>
      </VueDraggableResizable>
    </div>
    <div class="content">
      <v-skeleton-loader type="article" />
    </div>
  </div>
</template>

<script>
/**
 * @fileoverview Loading tab
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import VueDraggableResizable from "vue-draggable-resizable";

export default {
  name: "LoadingTab",
  components: { VueDraggableResizable },
};
</script>

<style lang="scss" scoped>
.config-tab {
  display: flex;
  height: 100%;
  .resizable {
    height: 100% !important; // VueDraggableResizable doesn't allow setting this as a height
  }
  &::v-deep {
    .handle {
      box-sizing: border-box;
      position: absolute;
      width: 10px;
      height: 100%;
      top: -$qvo-spacing-24;
    }
    .handle-mr {
      right: 0;
      cursor: e-resize;
      z-index: 1;
    }
  }
}
.content {
  width: 100%;
  margin: $qvo-spacing-24;
}
.resize-wrapper {
  padding-top: $qvo-spacing-24;
  background: $qvo-color-blue-100;
}

nav {
  background: $qvo-color-blue-100;
  padding: $qvo-spacing-24;
  padding-top: 0;
  position: sticky;
  top: $qvo-spacing-24;
}
.v-skeleton-loader {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>